// extracted by mini-css-extract-plugin
export default {"toolbar":"ReportTabs_toolbar__LDWId","exportButton":"ReportTabs_exportButton__bUQeI"};